(function () {
  'use strict';

  /* @ngdoc object
   * @name helpers.sv
   * @description
   *
   */
  angular
    .module('helpers.sv', [
      'ui.router'
    ]);
}());
